module.exports = __webpack_public_path__ + "img/framework3_Image.29c29925.png";